"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledStatSummary = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _StyledStatSummary = require("./StyledStatSummary.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StyledStatSummary = function StyledStatSummary(_ref) {
  var testId = _ref.testId,
    style = _ref.style,
    data = _ref.data;
  var classes = (0, _StyledStatSummary.useStyles)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": testId,
    className: classes.statBox,
    style: style
  }, data.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.Box, {
      className: classes.statBoxItem
    }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "subtitle2",
      className: classes.statBoxTitle
    }, item.key), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      className: classes.statBoxItemName
    }, item.value));
  }));
};
exports.StyledStatSummary = StyledStatSummary;